var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 7.5,
    stroke: "#002857"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1722_27151)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1722_27151",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 12H12V30H30V12Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1722_27151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9975 24.2489C19.205 24.2489 17.75 22.7939 17.75 21.0014C17.75 19.2089 19.205 17.7539 20.9975 17.7539C22.79 17.7539 24.245 19.2089 24.245 21.0014C24.245 22.7939 22.79 24.2489 20.9975 24.2489ZM20.9975 18.8789C19.8275 18.8789 18.875 19.8314 18.875 21.0014C18.875 22.1714 19.8275 23.1239 20.9975 23.1239C22.1675 23.1239 23.12 22.1714 23.12 21.0014C23.12 19.8314 22.1675 18.8789 20.9975 18.8789Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9986 27.7663C18.1786 27.7663 15.5161 26.1164 13.6861 23.2514C12.8911 22.0139 12.8911 19.9964 13.6861 18.7513C15.5236 15.8863 18.1861 14.2363 20.9986 14.2363C23.8111 14.2363 26.4736 15.8863 28.3036 18.7513C29.0986 19.9889 29.0986 22.0064 28.3036 23.2514C26.4736 26.1164 23.8111 27.7663 20.9986 27.7663ZM20.9986 15.3613C18.5761 15.3613 16.2586 16.8163 14.6386 19.3588C14.0761 20.2364 14.0761 21.7664 14.6386 22.6439C16.2586 25.1864 18.5761 26.6413 20.9986 26.6413C23.4211 26.6413 25.7386 25.1864 27.3586 22.6439C27.9211 21.7664 27.9211 20.2364 27.3586 19.3588C25.7386 16.8163 23.4211 15.3613 20.9986 15.3613Z",
    fill: "#002857"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1722_27151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeBorder);
export default __webpack_public_path__ + "static/media/eye-border.24eefdd50d6fe30dcaef4832a1490cf1.svg";
export { ForwardRef as ReactComponent };